import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/layout.css';
import './styles/login.css';
import './styles/survey.css';
import './styles/admin.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
